import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CurrentSkedTask} from 'src/app/core/model/task';
import {getTaskPercentComplete} from 'src/app/current-sked/shared/utils/get-task-percent-complete';
import {Project} from 'src/app/core/model/project';

@Component({
  selector: 'current-sked-task-list-default-theme-active-task',
  templateUrl: './current-sked-task-list-default-theme-active-task.component.html',
  styleUrls: ['./current-sked-task-list-default-theme-active-task.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentSkedTaskListDefaultThemeActiveTaskComponent implements OnChanges {
  @Input() task: CurrentSkedTask;
  @Input() project: Project;

  percentCompleteDisplay: string;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.task && this.task) {
      this.percentCompleteDisplay = getTaskPercentComplete(this.task).display;
    }
  }
}
